import React from "react";
import "./chainedFiveWhys.css";

/**
 * ChainTabs - Tab navigation for multiple chains
 * Displays Chain A, Chain B, etc. with labels and delete buttons
 */
function ChainTabs({ chains, activeChainId, onSelectChain, onAddChain, onDeleteChain }) {
   
  return (
    <div className="chain-tabs-container">
      <div className="chain-tabs">
        {chains.map((chain) => (
          <div
            key={chain.chainId}
            className={`chain-tab ${activeChainId === chain.chainId ? 'active' : ''}`}
            onClick={() => onSelectChain(chain.chainId)}
          >
            <span className="chain-tab-letter">{chain.chainLetter}</span>
            <span className="chain-tab-label">
              {chain.chainLabel ? `Chain ${chain.chainLetter} — ${chain.chainLabel}` : `Chain ${chain.chainLetter}`}
            </span>
            <button
              className="chain-tab-delete"
              onClick={(e) => {
                e.stopPropagation();
                onDeleteChain(chain.chainId);
              }}
              title="Delete chain"
              aria-label={`Delete Chain ${chain.chainLetter}`}
            >
              ×
            </button>
          </div>
        ))}
        
        <button className="chain-tab-add" onClick={onAddChain} title="Add new chain">
          <span className="add-icon">+</span>
          <span className="add-label">Add chain</span>
        </button>
      </div>
    </div>
  );
}

export default ChainTabs;
